//angular.module('ll.calculationPackage', []).controller('CalculationPackagesCtrl', ['$scope', '$http', '$modal', 'toaster', 'filterFilter', function ($scope, $http, $modal, toaster, filterFilter) {
angular.module('ll.calculationPackage', []).controller('CalculationPackagesCtrl', ['$scope', '$http', '$modal', 'toaster', 'filterFilter', '$window', 'FileUploader', function ($scope, $http, $modal, toaster, filterFilter, $window, FileUploader) {
    $scope.Partners = [];
    // pobranie partnerow
    $http.get('/offerbusinessdata/getpartners').then(function (d) {
        $scope.Partners = [];
        $scope.Partners = _.map(d.data, function (i) {
            return { k: i.Guid, v: i.Name, url: i.PartnerUrl };
        });
    }, function (e) { console.log(e); });

    //$scope.requests = [];
    $scope.filteredList = [];
    //$scope.filteredProductsList [];
    $scope.search = {
        PackageId: "",
        PackageName: "",
        PackageGroupId: "",
        ProduktType: "",
        Validfrom: "",
        Validto: "",
        Procestill: "",
        Priority: ""
    };

    $scope.CalculationPackageModels = [];

    // dla produktow
    //$scope.CalculationPackageProducts = [];

    // filtr
    $scope.filterRequest = function (item) {

        if ($scope.search.PackageName) {
            var _v0 = ($scope.search.PackageName || "").toLowerCase();
            var _v1 = (item.PackageName + "" || "").toLowerCase();
            if (_v1.indexOf(_v0) == -1) return false;
        }
        /*
                if ($scope.search.Partner) {
                    var _v0 = ($scope.search.Partner || "").toLowerCase();
                    var _v1 = (item.Partner + "" || "").toLowerCase();
                    if (_v1 !== _v0) return false;
                }*/
        return true;
    };


    // obserwowanie filtra i glownego zbioru danych
    $scope.$watch('search', function () {
        $scope.filteredList = filterFilter($scope.CalculationPackageModels, $scope.filterRequest);
    }, true);

    $scope.$watch('CalculationPackageModels', function () {
        $scope.filteredList = filterFilter($scope.CalculationPackageModels, $scope.filterRequest);
    }, true);

    //dla produktow
    /*
    $scope.$watch('CalculationPackageProducts', function () {
        $scope.filteredProductsList = filterFilter($scope.CalculationPackageProducts, $scope.filterRequest);
    }, true);*/


    // pobieranie danych
    $scope.Refresh = function () {
        $http.get('/api/CalculationPackage').then(
            function (d) {
                $scope.CalculationPackageModels = d.data.Result;
            },
            function (e) {
                toaster.pop('error', 'Pobieranie danych nie powiodło się');
            });
    };

    $scope.PublishSavedConfiguration = function () {
        $http.post('/api/CalculationPackagePublish').then(
            function (d) {
                toaster.pop('success', 'Pakiet wygenerowano poprawnie');
                //$window.open('/CalculationPackageFile/Download');
            },
            function (e) {
                toaster.pop('error', 'Pobieranie danych nie powiodło się');
            });
    };

    $scope.DownloadCurrent = function () {
        $window.open('/CalculationPackageFile/Download');
    };

    $scope.UploadConfiguration = function () {
        // zbudowanie URL do zaladowania
        var url = '/CalculationPackageFile/Upload';

        // ladowacz
        $scope.uploader = new FileUploader({
            url: url
        });
        $scope.uploader.onErrorItem = function (fileItem, response, status, headers) {
            toaster.pop('error', 'Błąd podczas zapisywania pliku');
        };
        $scope.uploader.onSuccessItem = function (fileItem, response, status, headers) {
            fileItem.complete = true;
            toaster.pop('success', 'Plik zapisano poprawnie');
        };
        $scope.uploader.onCompleteItem = function (fileItem, response, status, headers) {
            fileItem.complete = true;
            toaster.pop('info', 'Przesył pliku zakończony poprawnie');
        };
        $scope.uploader.onBeforeUploadItem = function (fileItem) {
            fileItem.formData = $scope.uploader.formData;
        }

        var modalInstance = $modal.open({
            animation: true,
            templateUrl: '/WWW/partials/modules/calculation.package/uploadConfigurationModal.html',
            controller: 'UploadConfigurationModalCtrl',
            scope: $scope,
            resolve: {
                uploader: function () {
                    return $scope.uploader;
                }
            }
        });

        modalInstance.result.then(
            function (d) {
                $scope.uploader.onCompleteAll = function () {
                    toaster.pop('success', 'Pomyślnie zaktualizowano dane pakietowe');
                    $scope.Refresh();
                };
                $scope.uploader.uploadAll();
            },
            function (e) { }
        );
    };


    $scope.DeleteCalculationPackage = function (id) {
        if (confirm("Czy na pewno chcesz usunąć produkt?")) {
            $http.delete('/api/CalculationPackage/' + id).then(
                function (d) {
                    toaster.pop('success', 'Operacja powiodła się');
                    $scope.Refresh();
                },
                function (e) {
                    toaster.pop('error', 'Operacja nie powiodła się');
                });
        };
    };

    $scope.AddCalculationPackage = function () {

        $scope.dataForNewCalculationPackage = {
            /*CalculationPackageGuid: "",
            PackageId: "",*/
            PackageName: "",
            PackageGroupId: "",
            ProduktType: "",
            Validfrom: "",
            Validto: "",
            Procestill: "",
            Priority: ""
        };

        var modalInstance = $modal.open({
            animation: true,
            templateUrl: '/WWW/partials/modules/calculation.package/addCalculationPackageModal.html',
            controller: 'AddCalculationPackageModalCtrl',
            scope: $scope,
            resolve: {
                dataForNewCalculationPackage: function () {
                    return $scope.dataForNewCalculationPackage;
                }
            }
        });

        modalInstance.result.then(
            function (dataForNewCalculationPackage) {
                $http.post('/api/CalculationPackage/', dataForNewCalculationPackage).then(
                    function (d) {
                        $scope.Refresh();
                        toaster.pop('success', 'Pomyślnie dodano nowy produkt');
                    },
                    function (e) {
                        toaster.pop('error', 'Błąd podczas dodawania nowego produktu');
                    });
            },
            function (e) { }
        );
    };
    /* // stara funkcja - do modala
        $scope.CheckPackageProducts = function (item) {
            $scope.currentPackageId = item.PackageId;
            var modalInstance = $modal.open({
                animation: true,
                templateUrl: '/WWW/partials/checkPackageProductsModal.html',
                controller: 'CheckPackageProductsModalCtrl',
                scope: $scope,
                resolve: {
                    item: function () {
                        return item;
                    }
                }
            });
    
            modalInstance.result.then(function(partners){
                var filtered = _.filter(partners, function(partner){
                    return partner.isConnected;
                });
    
                var rules = {
                    PartersGuids: _.map(filtered, function (partner) {
    
                        return partner.PartnerGuid;
                    })
                };
    
                $http.put('/api/CalculationPackageRole/' + partners[0].PackageId, rules).then(
                    function(d){
                        toaster.pop('success', 'Pomyślnie zaktualizowano partnerów');
                    }
                );
            }, function(){});
    
        }*/

    $scope.showPackageProducts = function (item) {
        $scope.currentPackage = item;
        $scope.PackageFunc = "PackageProducts";

    };

    // powrót do widoku pakietów kalkulacyjnych
    $scope.backToPackages = function () {
        $scope.PackageFunc = "Default";
        $scope.Refresh();
    };

    $scope.EditCalculationPackage = function (calculationPackage) {
        $scope.dataForEditCalculationPackage = calculationPackage;
        $scope.dataForEditCalculationPackage.Validfrom = new Date($scope.dataForEditCalculationPackage.Validfrom);
        $scope.dataForEditCalculationPackage.Validto = new Date($scope.dataForEditCalculationPackage.Validto);
        $scope.dataForEditCalculationPackage.Procestill = new Date($scope.dataForEditCalculationPackage.Procestill);

        var modalInstance = $modal.open({
            animation: true,
            templateUrl: '/WWW/partials/modules/calculation.package/editCalculationPackageModal.html',
            controller: 'EditCalculationPackageModalCtrl',
            scope: $scope,
            resolve: {
                dataForEditCalculationPackage: function () {
                    return $scope.dataForEditCalculationPackage;
                }
            }
        });

        modalInstance.result.then(
            function (dataForEditCalculationPackage) {
                $http.put('/api/CalculationPackage/' + dataForEditCalculationPackage.PackageId, dataForEditCalculationPackage).then(
                    function (f) {
                        $scope.Refresh();
                        toaster.pop('success', 'Pomyślnie zaktualizowano dane produktu');
                    },
                    function (g) {
                        toaster.pop('error', 'Błąd podczas aktualizacji danych produktu');
                    });
            },
            function (h) { }
        );
    };


    // pobranie danych na wejsciu
    $scope.Refresh();
    // produktow
    //$scope.RefreshProducts();

}])
    .controller('AddCalculationPackageModalCtrl', ['$scope', '$modalInstance', 'dataForNewCalculationPackage', function ($scope, $modalInstance, dataForNewCalculationPackage) {
        $scope.dataForNewCalculationPackage = dataForNewCalculationPackage;

        $scope.ok = function () {
            $modalInstance.close($scope.dataForNewCalculationPackage);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }])
    .controller('UploadConfigurationModalCtrl', [
        '$scope', '$modalInstance', 'uploader', function ($scope, $modalInstance, uploader) {
            $scope.uploader = uploader;

            $scope.ok = function () {
                $modalInstance.close();
            };

            $scope.cancel = function () {
                $modalInstance.dismiss('cancel');
            };
        }
    ])
    .controller('CheckPackageProductsModalCtrl', ['$scope', '$http', 'toaster', 'filterFilter', '$modal', function ($scope, $http, toaster, filterFilter, $modal) {
        //$scope.item = item;
        $scope.currentTab = "";
        $scope.CalculationPackageProducts = [];
        $scope.AllProducts = [];
        $scope.filteredProductsList = [];

        $scope.search = {
            name: ""
        };
        $scope.searchAll = {
            name: ""
        };
        $scope.searchPartners = {
            name: ""
        };


        $scope.filterRequest = function (item) {

            if ($scope.search.name) {
                var _v0 = ($scope.search.name || "").toLowerCase();
                var _v1 = (item.SubProduct.FinancialProductName + "" || "").toLowerCase();
                if (_v1.indexOf(_v0) == -1) return false;
            }
            return true;
        };

        $scope.filterRequestAll = function (item) {

            if ($scope.searchAll.name) {
                var _v0 = ($scope.searchAll.name || "").toLowerCase();
                var _v1 = (item.FinancialProductName + "" || "").toLowerCase();
                if (_v1.indexOf(_v0) == -1) return false;
            }
            return true;
        };
        $scope.filterRequestPartners = function (item) {

            if ($scope.searchPartners.name) {
                var _v0 = ($scope.searchPartners.name || "").toLowerCase();
                var _v1 = (item.Name + "" || "").toLowerCase();
                if (_v1.indexOf(_v0) == -1) return false;
            }
            return true;
        };
        $scope.RefreshProducts = function () {
            $http.get('/api/CalculationPackageProduct' + '?PackageId=' + $scope.currentPackage.PackageId).then(
                function (d) {
                    $scope.CalculationPackageProducts = d.data.Result;
                },
                function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
        };

        $scope.isMoving = false;

        $scope.MoveUp = function (toMoveUp) {
            var toMoveDown = (_.filter($scope.CalculationPackageProducts, function (obj) {
                return obj.PackageProduct.Hierarchy === toMoveUp.PackageProduct.Hierarchy - 1;
            }))[0];
            //console.log(toMoveDown);
            toMoveDown.PackageProduct.Hierarchy = toMoveUp.PackageProduct.Hierarchy;
            toMoveUp.PackageProduct.Hierarchy = toMoveUp.PackageProduct.Hierarchy - 1;

            $scope.UpdatePackageProduct(toMoveUp.PackageProduct);

            $scope.UpdatePackageProduct(toMoveDown.PackageProduct);

            $scope.CalculationPackageProducts = _.sortBy($scope.CalculationPackageProducts, function (product) { return product.PackageProduct.Hierarchy });
        };

        $scope.MoveDown = function (toMoveDown) {
            var toMoveUp = (_.filter($scope.CalculationPackageProducts, function (obj) {
                return obj.PackageProduct.Hierarchy === toMoveDown.PackageProduct.Hierarchy + 1;
            }))[0];
            toMoveUp.PackageProduct.Hierarchy = toMoveDown.PackageProduct.Hierarchy;
            toMoveDown.PackageProduct.Hierarchy = toMoveDown.PackageProduct.Hierarchy + 1;

            $scope.UpdatePackageProduct(toMoveUp.PackageProduct);

            $scope.UpdatePackageProduct(toMoveDown.PackageProduct);

            $scope.CalculationPackageProducts = _.sortBy($scope.CalculationPackageProducts, function (product) { return product.PackageProduct.Hierarchy });
        };

        $scope.GetAllProducts = function () {
            $http.get('/api/LeaselinkSubProduct?packageKey=' + $scope.currentPackage.PackageId + '&partitionKey=').then(
                function (d) {
                    $scope.AllProducts = d.data.Result;
                },
                function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
        };

        $scope.UpdatePackageProduct = function (product) {
            $scope.isMoving = true;
            $http.put('/api/CalculationPackageProduct/' + product.Guid, product).then(
                function (d) {
                    $scope.isMoving = false;
                },
                function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
        };

        $scope.AddToPackage = function (product) {
            var itemForPackage = {
                ProductGuid: product.Guid,
                PackageId: $scope.currentPackage.PackageId,
                Hierarchy: $scope.CalculationPackageProducts.length + 1
            };

            $http.post('/api/CalculationPackageProduct', itemForPackage).then(
                function (d) {
                    //$scope.RefreshProducts();
                    $scope.GetAllProducts();
                    $scope.CalculationPackageProducts.push({ PackageProduct: itemForPackage, SubProduct: {} });
                },
                function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });
        };

        $scope.RemoveFromPackage = function (product) {
            $http.delete('/api/CalculationPackageProduct/' + product.Guid).then(
                function (d) {
                    $scope.RefreshProducts();
                },
                function (e) {
                    toaster.pop('error', 'Usuwanie danych nie powiodło się');
                });
        };

        // funkcja do dzielenia na kolumny
        function chunk(arr, size) {
            var newArr = [];
            for (var i = 0; i < arr.length; i += size) {
                newArr.push(arr.slice(i, i + size));
            }
            return newArr;
        }

        $scope.PartnersRules = [];

        $scope.$watch('search', function () {
            $scope.filteredProductsList = filterFilter($scope.CalculationPackageProducts, $scope.filterRequest);
        }, true);

        $scope.$watch('searchAll', function () {
            $scope.filteredProductsList = filterFilter($scope.AllProducts, $scope.filterRequestAll);
        }, true);
        $scope.$watch('searchPartners', function () {
            $scope.filteredPartnersList = filterFilter($scope.PartnersRules, $scope.filterRequestPartners);

            $scope.chunkedPartners = chunk($scope.filteredPartnersList, 3);
        }, true);

        $scope.$watch('CalculationPackageProducts', function () {
            $scope.filteredProductsList = filterFilter($scope.CalculationPackageProducts, $scope.filterRequest);
        }, true);
        $scope.$watch('AllProducts', function () {
            $scope.filteredProductsList = filterFilter($scope.AllProducts, $scope.filterRequestAll);
        }, true);


        $scope.$watch('currentTab', function () {
            if ($scope.currentTab == "productsIncludedInPackage") {
                $scope.RefreshProducts();
                $scope.filteredProductsList = filterFilter($scope.CalculationPackageProducts, $scope.filterRequest);
            }
            if ($scope.currentTab == "allProducts") {
                $scope.GetAllProducts();
                $scope.filteredProductsList = filterFilter($scope.AllProducts, $scope.filterRequestAll);
            }
            if ($scope.currentTab == "connectedPartners") {
                $http.get('/api/CalculationPackageRole?packageId=' + $scope.currentPackage.PackageId).then(function (d) {
                    $scope.PartnersRules = d.data.Result;

                    $scope.chunkedPartners = chunk($scope.PartnersRules, 3);

                }, function (e) { console.error(e); });
            }
        }, true);

        $scope.savePartners = function () {
            var filtered = _.filter($scope.PartnersRules, function (partner) {
                return partner.isConnected;
            });

            var rules = {
                PartersGuids: _.map(filtered, function (partner) {

                    return partner.PartnerGuid;
                })
            };

            $http.put('/api/CalculationPackageRole/' + $scope.PartnersRules[0].PackageId, rules).then(
                function (d) {
                    toaster.pop('success', 'Pomyślnie zaktualizowano partnerów');
                }
            );

        };

        $scope.ShowLinkedProducts = function (financialItem) {
            $scope.currentCalculationPackageId = financialItem.PackageProduct.PackageId;
            $scope.currentFinancialProductId = financialItem.SubProduct.Guid;

            $http.get('/api/CalculationPackageLinkedNonFinancialProduct?packageId=' + $scope.currentCalculationPackageId + '&parentProductId=' + $scope.currentFinancialProductId).then(

                function (d) {
                    $scope.LinkedNonFinancialProduct = d.data.Result;
                    var modalInstance = $modal.open({
                        animation: true,
                        templateUrl: '/WWW/partials/modules/calculation.package/showLinkedProductsModal.html',
                        controller: 'ShowLinkedProductsModalCtrl',
                        scope: $scope,
                        size: "lg"
                    });

                    modalInstance.result.then(
                        function (financialItem) {

                        },
                        function () {
                        }
                    );


                },
                function (e) {
                    toaster.pop('error', 'Pobieranie danych nie powiodło się');
                });

        };

    }])


    .controller('EditCalculationPackageModalCtrl', ['$scope', '$modalInstance', 'dataForEditCalculationPackage', function ($scope, $modalInstance, dataForEditCalculationPackage) {
        $scope.dataForEditCalculationPackage = dataForEditCalculationPackage;

        $scope.ok = function () {
            $modalInstance.close($scope.dataForEditCalculationPackage);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }])

    .controller('ShowLinkedProductsModalCtrl', ['$scope', '$http', '$modalInstance', 'toaster', 'filterFilter', function ($scope, $http, $modalInstance, toaster, filterFilter) {
        $scope.obligatoryOptions = [
            { value: 2, name: 'Obligatoryjny' },
            { value: 1, name: 'Nieobligatoryjny' },
            { value: 0, name: 'Nieokreślony' }
        ];

        var keys = Object.keys($scope.LinkedNonFinancialProduct.LinkedProductsDictionary);
        var i;
        $scope.LinkProd = [];

        for (i = 0; i < keys.length; i++) {
            $scope.LinkProd[i] = $scope.LinkedNonFinancialProduct.LinkedProductsDictionary[keys[i]];//.LinkedProductName;
        };

        $scope.filteredProductsList = [];

        $scope.searchNonFinancialProducts = {
            name: ""
        };

        $scope.filterRequest = function (item) {
            if ($scope.searchNonFinancialProducts.name) {
                var _v0 = ($scope.searchNonFinancialProducts.name || "").toLowerCase();
                //if (!$scope.LinkedNonFinancialProduct.LinkedProductsDictionary.hasOwnProperty(item)) return false;
                var _v1 = (item.LinkedProductName + "" || "").toLowerCase();
                if (_v1.indexOf(_v0) == -1) return false;
            }
            return true;
        };

        $scope.$watch('searchNonFinancialProducts', function () {
            $scope.filteredProductsList = filterFilter($scope.LinkProd, $scope.filterRequest);
        }, true);
        $scope.searchNonFinancialProducts = "";

        $scope.$watch('LinkedNonFinancialProduct.LinkedProductsDictionary', function () {
            $scope.filteredProductsList = filterFilter($scope.LinkProd, $scope.filterRequest);
        }, true);

        $scope.saveLinkedProducts = function () {
            $http.post("/api/CalculationPackageLinkedNonFinancialProduct", $scope.LinkedNonFinancialProduct).then(function (d) {
                $scope.LinkedNonFinancialProduct = d.data;
                $modalInstance.close($scope.item);
            }, function (e) {
                console.error(e);
                toaster.pop('error', "Produkty", "Błąd przy zapisywaniu danych");
            });
        };


        $scope.ok = function () {
            $modalInstance.close($scope.financialItem);
        };

        $scope.cancel = function () {
            $modalInstance.dismiss('cancel');
        };
    }]);